import { useEmpresa } from "app/contexts";
import { AddLink, DeleteButton, EditLink } from "app/components/buttons";
import { Table } from "app/components/table";
import { DFlexResponsive } from "app/components/d-flex-responsive";
import { Container } from "app/components/container";
import { Row } from "app/components/row";
import { Column } from "app/components/column";

export function TelefonosTable() {
  const { empresa, deleteTelefono } = useEmpresa();

  return (
    <Container>
      <Row>
        <Column>
          <DFlexResponsive justifyContent="between">
            <h5>
              <strong>Números de teléfono fijo (opcional)</strong>
            </h5>

            <AddLink to="telefonos/add" title="Agregar número de teléfono" />
          </DFlexResponsive>
        </Column>

        <Column>
          {!!empresa.telefonos.length ? (
            <Table
              responsive
              titles={["#", "Tipo", "Número de teléfono", "Opciones"]}
            >
              {empresa.telefonos.map((telefono, i) => (
                <tr key={i}>
                  <td className="text-center">{i + 1}</td>

                  <td>
                    {telefono.telefono_principal ? "Principal" : "Secundario"}
                  </td>

                  <td>{telefono.telefono_numero}</td>

                  <td>
                    <DFlexResponsive>
                      <EditLink to={`telefonos/${i}/edit`} />

                      <DeleteButton
                        size="sm"
                        onClick={() => deleteTelefono(i)}
                      />
                    </DFlexResponsive>
                  </td>
                </tr>
              ))}
            </Table>
          ) : (
            <p className="lead text-center">
              Por favor, agregue al menos un número de teléfono
            </p>
          )}
        </Column>
      </Row>
    </Container>
  );
}
